import { Bell, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NotificationBanner } from "./NotificationBanner";
import type { Notification } from "@/types/notifications";

interface NotificationsPanelProps {
  notifications: Notification[];
  onDismiss: (id: string) => void;
  onDismissAll: () => void;
  onMarkAsRead: (id: string) => void;
}

export const NotificationsPanel = ({
  notifications,
  onDismiss,
  onDismissAll,
  onMarkAsRead,
}: NotificationsPanelProps) => {
  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Bell className="w-4 h-4 text-primary" />
          <span className="text-sm font-medium">
            {notifications.length} notification{notifications.length !== 1 ? "s" : ""}
          </span>
        </div>
        {notifications.length > 1 && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onDismissAll}
            className="text-xs h-7"
          >
            <X className="w-3 h-3 mr-1" />
            Dismiss all
          </Button>
        )}
      </div>

      <div className="space-y-2">
        {notifications.map((notification) => (
          <NotificationBanner
            key={notification.id}
            notification={notification}
            onDismiss={onDismiss}
            onMarkAsRead={onMarkAsRead}
          />
        ))}
      </div>
    </div>
  );
};
